import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export type UnsavedChangesDecision = boolean | Promise<boolean> | Observable<boolean>;

export interface UnsavedChangesAware {
  hasUnsavedChanges(): boolean;
  confirmUnsavedChangesNavigation(): UnsavedChangesDecision;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesAware> = (component) => {
  if (!component?.hasUnsavedChanges()) {
    return true;
  }

  return component.confirmUnsavedChangesNavigation();
};
